import { DeleteCompanyInputProp } from '@commenda/types/src/company/types';
import { fetcher } from '@commenda/utils';

export default async function deleteCompany({
  data,
  token,
}: {
  data: DeleteCompanyInputProp;
  token?: string | undefined;
}): Promise<boolean> {
  try {
    const res = await fetcher(
      `company/${data?.companyId}/`,
      {
        method: 'DELETE',
        body: {},
      },
      token
    );

    return res.ok;
  } catch (err) {
    console.error(err);
    return false;
  }
}
